import {
  Box,
  Fade,
  IconButton,
  Modal,
  Typography,
  Divider,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  styled,
  DialogContent,
  DialogContentText
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import Button from "../../../Components/Button";
import confirm from "../../../Assets/SVG/confirm.svg";
import close from "../../../Assets/SVG/close.svg";
import { Link, useNavigate } from "react-router-dom";
import { addAdminUrl, createCompanyUrl } from "../../../Library/URLs";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    width: "552px",
    fontFamily: "Quicksand sans-serif",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontFamily: "Quicksand" }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  height: "auto",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  borderRadius: 2,
  boxSizing: "border-box",
  outline: "none",
};
const Model_Style = {
  position: "relative",
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  border: "none",
  p: 4,
};
const Close_Btn_Style = {
  position: "absolute",
  top: ".7rem",
  right: ".7rem",
};
const Left_Btn = {
  bgcolor: "#13ABF4",
  width: 142,
  height: 35,
  borderRadius: "3px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "14px",
  cursor: "pointer",
};
const Right_Btn = {
  bgcolor: "#636766",
  width: 142,
  height: 35,
  borderRadius: "3px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "14px",
  cursor: "pointer",
};

const Title_Style = {
  fontWeight: 500,
  fontSize: "32px",
  lineHeight: "120%",
  textAlign: "center",
  color: "#636766",
  marginTop: "1rem",
};

const Title2_Style = {
  fontWeight: 500,
  fontSize: "32px",
  lineHeight: "120%",
  textAlign: "center",
  color: "#636766",
};

const Text_Style = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "156.5%",
  textAlign: "center",
  color: "#636766",
  whiteSpace: "wrap",
};

const CompanyPersonnalDetail = ({ Pre, setTab, data: formData, setData }) => {
  const unique_id = uuid();
  const { User } = useSelector((state) => state.payroll);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();

  const [openCreate, setOpenCreate] = useState(false);
  const handleCreateClose = () => {
    setOpenCreate(false);
  }

  const validate = () => {
    if (
      formData?.company_name !== "" &&
      formData?.company_location !== "" &&
      formData?.company_email !== "" &&
      formData?.admin_first_name !== "" &&
      formData?.admin_last_name !== "" &&
      formData?.admin_email !== "" &&
      formData?.admin_phone_number !== ""
    ) {
      return true;
    } else {
      return false;
    }
  };

  const CreateAdmin = async () => {
    if(formData.first_name === "") {
      toast.error("Provide your first name");
      return;
    }
    if(formData.last_name === "") {
      toast.error("Provide your last name");
      return;
    }
    if(formData.email === "") {
      toast.error("Provide your email");
      return;
    }
    if(formData.password === "") {
      toast.error("Provide your password");
      return;
    }
    if(formData.password !== formData.confirm_password) {
      toast.error("Please make sure your password matches your confirm password");
      return;
    }
    setLoading(true)
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      ...formData,
    };
    await axios
      .post(addAdminUrl, data)
      .then((res) => {
        if(res?.data?.success) {
          setLoading(false);
          // Create_Btn();
          setOpen(true);
        } else {
          setLoading(false);
          toast.error(res?.data?.message)
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.data?.message);
        // console.log('Get all payroll error',err.message)
      });
  };
  const Create_Btn = () => {
    navigate("/companies");
    setTab((pre) => (pre = 1));
  };

  const handleChange = (e) => {
    setData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="Company_Detail_Wrap">
      <h3>Super Admin Details </h3>
      <div className="Top">
        <div className="Box">
          <label htmlFor="admin_first_name">First Name</label>
          <input
            type="text"
            id="first_name"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
          />
        </div>
        <div className="Box">
          <label htmlFor="last_name">Last Name</label>
          <input
            type="text"
            id="last_name"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="Box">
        <label htmlFor="email">Email Addresses</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />
      </div>
      <div className="Box">
        <label htmlFor="password">Password</label>
        <input
          type="password"
          id="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
        />
      </div>
      <div className="Box">
        <label htmlFor="confirm_password">Confirm Password</label>
        <input
          type="password"
          id="confirm_password"
          name="confirm_password"
          value={formData.confirm_password}
          onChange={handleChange}
        />
      </div>
      <div className="Button_Box">
        <IconButton aria-label="delete">{/* <DeleteIcon /> */}</IconButton>
        {/* <Button Click={Pre} name="Previous" /> */}
        <Button
          Click={() => {
            validate() ? setOpenCreate(true) : toast.error("Enter all details");
          }}
          style={{ backgroundColor: !(validate()) && "#636766" }}
          name="Create"
        />
      </div>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box sx={Model_Style}>
              <Box sx={Close_Btn_Style}>
                <img
                  style={{ cursor: "pointer" }}
                  onClick={handleClose}
                  src={close}
                  alt="avatar"
                />
              </Box>
              <Box sx={{ mt: 3 }}>
                <img src={confirm} alt="avatar" />
              </Box>
              <Typography
                sx={Title_Style}
                id="spring-modal-title"
                variant="h3"
                component="h2"
              >
                Admin created
              </Typography>
              <Typography
                sx={Title2_Style}
                id="spring-modal-title"
                variant="h3"
                component="h2"
              >
                Successfully!
              </Typography>
              <Typography
                sx={{ ...Text_Style, mt: 2 }}
                id="spring-modal-description"
                variant="p"
                component="p"
              >
                Kindly check your email
              </Typography>
              {/* <Typography
                sx={{ ...Text_Style, mt: 0 }}
                id="spring-modal-description"
                variant="p"
                component="p"
              >
                continue setting up your company.
              </Typography> */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                  justifyContent: "center",
                  mt: 3,
                  mb: 3,
                }}
              >
                <Box sx={Left_Btn}>
                  <Link
                    style={{ textDecoration: "none", color: "#ffffff" }}
                    to="/admins"
                  >
                    View Admin
                  </Link>
                </Box>
                {/* <Box sx={Right_Btn}>
                  <Link
                    style={{ textDecoration: "none", color: "#ffffff" }}
                    onClick={CreateCompany}
                    type="button"
                  >
                    {loading === false ? (
                      "Create Company"
                    ) : (
                      <CircularProgress color="inherit" size={14} />
                    )}
                  </Link>
                </Box> */}
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
      <BootstrapDialog
        open={openCreate}
        onClose={handleCreateClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCreateClose}
        >
          {/* <div className="Name">Proxy Employee</div> */}
        </BootstrapDialogTitle>
        <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
        <DialogContent sx={{ pb: 10 }}>
          <DialogContentText id="alert-dialog-description">
            You are about to create admin{" "}
            account
          </DialogContentText>
        </DialogContent>
        <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
        <DialogActions>
          <Button Click={handleCreateClose} variant="outlined">
            Cancel
          </Button>
          <Button
            Click={CreateAdmin}
            variant="contained"
            autoFocus
            style={{
              backgroundColor: "#13ABF4",
            }}
          >
            {loading ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "Proceed"
            )}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default CompanyPersonnalDetail;
